export enum ReservationErrorCodes {
    ERROR_052163 = '052163',
    ERROR_052109 = '052109',
    ERROR_052150 = '052150',
    ERROR_052113 = '052113',
    ERROR_052137 = '052137',
    ERROR_058800 = '058800',
    ERROR_052131 = '052131',
    ERROR_073501 = '073501',
    ERROR_073502 = '073502',
    ERROR_050535 = '050535',
    ERROR_052138 = '052138',
    ERROR_052149 = '052149',
    ERROR_GAPI_ROOM_AVAILABILITY = '701',
    RESERVATION_5061 = 'RESERVATION_5061',
    ERROR__RESERVATION_4340 = 'ResService4340',
    ERROR_RESERVATION_5057 =  'RESERVATION_5057',
    ERROR_RESERVATION_5070 = 'RESERVATION_5070',
    NOT_AUTHORIZED = 'NOT_AUTHORIZED',
    RESERVATION_5062 = 'RESERVATION_5062',
    ERROR_FREE_NIGHTS = 'ERROR_FREE_NIGHTS',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',

    /** v2 error codes **/

    //ERROR_052163 = 'CRS_15999',  // The number in party exceeds the maximum room occupancy.
    ERROR_MAX_OCCUPANCY_EXCEEDED = 'CRS_15999',  // The occupancy requested is higher than available for the product.
    ERROR_MAX_OCCUPANCY_EXCEEDED_AVAIL = 'CRS_50023',
    //ERROR_052109, ERROR_052150, ERROR_052113= 'CRS_15500',
    ERROR_PRODUCT_NOT_AVAILABLE = 'CRS_15500', // The requested product is not available.
    // ERROR_050535 = 'CRS_733', //A frequent guest number change requires a cancel and a rebook
    ERROR_LOYALTYID_UPDATE_NOT_ALLOWED = 'CRS_733', //You are not allowed to update loyaltyId in loyaltyProgram.
    // 'RESERVATION_5057, 5061, ERROR_052138 = 'CRS_12103', // The reservation system was unable to process your request. Please check all data to make sure it is correct
    ERROR_INVALID_PAYMENT_TRANSACTION_ID = 'CRS_12103', //Invalid length for /data/hotelReservation/segments[1]/formOfPayment/paymentByPoints[1]/transactionId [#value#] max expected: 9, got: xx
    //ERROR_052149 = 'CRS_12080', // The reservation cannot be viewed via the Internet
    ERROR_RESERVTION_NOT_ACCESSIBLE_VIA_WEB = 'CRS_12080', // Reservation not accessible by web and mobile
    //ERROR_052131 = '052131', //500- 052131, Deposit required.
    ERROR_DEPOSIT_REQUIRED = 'CRS_371', //403 CRS_371, deposit required
    //'073501', // RDM_073501
    ERROR_ALREADY_CHECKED_IN = 'RDM_073501',
    //'073502', // RDM_073502
    ERROR_SECURITY = 'RDM_073502',
    //'058800', //CRS_15575
    ERROR_INVALID_DATES = 'CRS_15575',
    //'ResService4340', // RES_4340
    ERROR_RESERVATION_ACCESS = 'RES_4340',
    //'RESERVATION_5070', // RES_5070
    ERROR_NOT_AUTHORIZED = 'RES_5070',
    ERROR_ALREADY_CANCELLED = 'CRS_95',
    ERROR_NO_ROOM_AVAILABILITY = 'CRS_50025',
    ERROR_INVALID_DATE_RANGE = 'RES_1011',
    ERROR_REQUIRED_CHECKED_IN = 'RES_70002'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/errors/reservation-error-codes.model.ts